import React from 'react';
import {
    PropsShell,
    PropsNotFound,
    PropsCommonFields,
    PropsSection,
    PropsField,
    PropsRequiredAndMeta,
    useQuestionProperties,
} from './QuestionPropertiesShared';

const RatingBlockProperties = ({ questionId }) => {
    const { question, localName, nameError, handleUpdate, handleNameChange } =
        useQuestionProperties(questionId);

    if (!question) return <PropsNotFound />;

    return (
        <PropsShell typeLabel="Rating" typeIcon="bi-star">
            <PropsCommonFields
                localName={localName}
                nameError={nameError}
                onNameChange={handleNameChange}
                title={question.title}
                description={question.description}
                onTitleChange={(value) => handleUpdate('title', value)}
                onDescriptionChange={(value) => handleUpdate('description', value)}
            />

            <PropsSection title="Rating scale">
                <PropsField label="Rating type">
                    <select
                        className="form-select form-select-sm"
                        value={question.ratingType || 'stars'}
                        onChange={(e) => handleUpdate('ratingType', e.target.value)}
                    >
                        <option value="stars">Stars</option>
                        <option value="numbers">Numbers</option>
                        <option value="scale">Scale</option>
                    </select>
                </PropsField>

                <div className="ecx-survey-props__row">
                    <PropsField label="Minimum value">
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            min={1}
                            max={10}
                            value={question.minValue || 1}
                            onChange={(e) =>
                                handleUpdate('minValue', parseInt(e.target.value, 10) || 1)
                            }
                        />
                    </PropsField>
                    <PropsField label="Maximum value">
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            min={2}
                            max={10}
                            value={question.maxValue || 5}
                            onChange={(e) =>
                                handleUpdate('maxValue', parseInt(e.target.value, 10) || 5)
                            }
                        />
                    </PropsField>
                </div>

                <div className="ecx-survey-props__row">
                    <PropsField label="Minimum label">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Poor"
                            value={question.minLabel || ''}
                            onChange={(e) => handleUpdate('minLabel', e.target.value)}
                        />
                    </PropsField>
                    <PropsField label="Maximum label">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Excellent"
                            value={question.maxLabel || ''}
                            onChange={(e) => handleUpdate('maxLabel', e.target.value)}
                        />
                    </PropsField>
                </div>
            </PropsSection>

            <PropsRequiredAndMeta
                required={question.required}
                onRequiredChange={(value) => handleUpdate('required', value)}
                questionId={questionId}
            />
        </PropsShell>
    );
};

export default RatingBlockProperties;
